import { Component, OnInit } from '@angular/core';
import { AppState } from '../../../../../app.reducer';
import { Store } from '@ngrx/store';
import { GetReplacementPatterns, DeleteReplacementPattern } from '../../store/templates.actions';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatTableDataSource } from '@angular/material';
import { Location } from '@angular/common';
import { AddReplacementPatternDialogComponent } from '../add-replacement-pattern-dialog/add-replacement-pattern-dialog.component'
import { NotificationModalComponent } from 'src/app/features/common-components/notification-modal/notification-modal.component';

@Component({
    selector: 'app-modify-replacement-pattern',
    templateUrl: './modify-replacement-pattern.component.html',
    styleUrls: ['./modify-replacement-pattern.component.scss']
})
export class ModifyReplacementPatternComponent implements OnInit {
    replacementPatterns: Array<any> = [];
    displayedColumns: string[] = ['Term', 'Details', 'Action'];
    dataSource: MatTableDataSource<any>;

    constructor(
        private store: Store<AppState>,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private dialog: MatDialog,
        private location: Location
    ) { }

    ngOnInit() {
        this.store.dispatch(new GetReplacementPatterns({ search: "" }));

        this.store.select(state => state.template.replacementPatternsList).subscribe((replacementPatternsList: Array<any>) => {
            if (replacementPatternsList) {
                // this.replacementPatterns = replacementPatternsList;
                this.dataSource = new MatTableDataSource(replacementPatternsList);
            }
        })
    }

    openAddNewReplacementPatternDialog(type: string, patternId: string) {
        const dialogObj = {
            hasBackdrop: true,
            width: '700px',
            panelClass:'cmp-modal',
            data: {}

        }

        if (type == "edit") {
            dialogObj.data['title'] = "Edit Pattern"
            dialogObj.data["type"] = "edit";
            dialogObj.data["patternId"] = patternId;
        }
        else {
            dialogObj.data['title'] = "Add Pattern"
            dialogObj.data["type"] = "add";
        }

        const dialogref = this.dialog.open(AddReplacementPatternDialogComponent, dialogObj);
    }


    deleteReplacementPattern(patternId: string) {
        const dialogRef = this.dialog.open(NotificationModalComponent, {
            width: "500px",
            panelClass: 'cmp-modal',
            data: {
                text: "Are you sure want to delete this replacement pattern ? "
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.store.dispatch(new DeleteReplacementPattern(patternId));
            }
        });
    }

    cancel() {
        this.location.back();
    }

}
